<template>
  <div class="beitragszahlung">

    <v-row no-gutters align="start">

      <v-col cols="12"
             sm="3"
             class="pt-1" >
        <label class="dmb-form-text">Zahlungsart*
          <site-tooltip>
            Die vierteljährliche oder monatliche Zahlweise ist nur in Verbindung mit<br>einem SEPA-Lastschrift-Mandat möglich.
          </site-tooltip>
        </label>
      </v-col>

      <v-col cols="12"
             sm="9">
        <v-radio-group v-model="rechnungszahler"
                       hide-details
                       name="zahlungsart"
                       row>

          <v-radio label="SEPA-Lastschrift-Mandat"
                   value="N"
                   color="primary" />

          <v-radio label="Rechnung"
                   value="J"
                   color="primary" />

          <v-radio v-if="maklerinkassoAllowed" 
                   label="Maklerinkasso"
                   value="M"
                   color="primary" />
        </v-radio-group>
      </v-col>

    </v-row>

    <v-row no-gutters
           align="start"
           class="mb-n4" >

      <v-col cols="12"
             sm="3"
             class="pt-1" >
        <label class="dmb-form-text">Zahlweise*
          <site-tooltip>
            Die vierteljährliche oder monatliche Zahlweise ist erst ab einem Beitrag von {{ $helpers.toGermanIntegerString(premiumMinimum) }}&nbsp;€ möglich.
          </site-tooltip>
        </label>
      </v-col>

      <v-col cols="12"
             sm="9">
        <v-radio-group v-model="zahlweise"
                       hide-details
                       name="zahlweise" >

          <v-radio value="1"
                   color="primary">
            <span slot="label">jährlich {{ $helpers.toGermanFloatString(praemie.z1) }}&nbsp;€ </span>
          </v-radio>

          <v-radio value="2"
                   color="primary"
                   class="pt-4">
            <span slot="label">halbjährlich {{ $helpers.toGermanFloatString(praemie.z2) }}&nbsp;€ </span>
          </v-radio>

          <template v-if="rechnungszahler === 'N' || rechnungszahler === 'M'">

            <v-radio v-if="praemie.z4 >= premiumMinimum"
                     value="4"
                     color="primary"
                     class="pt-4">
              <span slot="label">vierteljährlich {{ $helpers.toGermanFloatString(praemie.z4) }}&nbsp;€ </span>
            </v-radio>

            <v-radio v-if="praemie.z12 >= premiumMinimum"
                     value="12"
                     color="primary"
                     class="pt-4">
              <span slot="label">monatlich {{ $helpers.toGermanFloatString(praemie.z12) }}&nbsp;€ </span>
            </v-radio>

          </template>
        </v-radio-group>
      </v-col>

    </v-row>

    <template v-if="rechnungszahler === 'N'">
      <konto-verbindung></konto-verbindung>
    </template>

  </div>
</template>

<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import KontoVerbindung from './KontoVerbindung';
import { RIGHTS } from '@/store/user';

export default {
  components: { KontoVerbindung },
  mixins: [twowayBinding, ValidationMixin],
  data() {
    return {
      premiumMinimum: 15
    };
  },
  computed: {
    maklerinkassoAllowed() {
      return this.$store.getters.checkAuthorization(RIGHTS.MAKLERINKASSO);
    },
    ...mapTwoWay([
      'rechnungszahler',
      'zahlweise',
      'praemie'
    ], {}, 'gewerbe.vertrag')
  },
  watch: {
    rechnungszahler(value) {
      if (value === 'J' && (this.zahlweise === '12' || this.zahlweise === '4')) {
        this.zahlweise = '2';
        this.$store.commit('setSnackbarError', {
              message: "Vierteljährliche oder monatliche Zahlweise ist nur in Verbindung mit SEPA-Lastschrift-Mandat möglich.",
              timeout: 10000,
              closebutton: true,
              isInfo: true
            });
      }
    },
    praemie: {
      deep: true,
      handler() {
        if (this.zahlweise === '12' && this.praemie.z12 < this.premiumMinimum ||
          this.zahlweise === '4' && this.praemie.z4 < this.premiumMinimum) {
          this.zahlweise = '2';
        }
      }
    }
  }
};
</script>
<style>
  .beitragszahlung .v-input--radio-group__input .v-radio:not(:last-child) {
    margin-right: 48px!important;
  }
</style>
